import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "../Hooks/useFetch";
import { accountsURL, organizationsURL } from "../Hooks/URL";
import { userContext } from "../Contexts/userContext";
import Accounts from "../Templates/Home/Accounts/Accounts";

function AccountsPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Open, setOpen] = useState(false);
  const [sortBy, setSortBy] = useState("registeredAt");
  const [sortOrder, setSortOrder] = useState(true);
  const [filters, setFilters] = useState({
    paid: "",
    referralSource: "",
    type: "",
    organizationId: "",
    hasTeams: "",
  });

  const getFilterQueryString = (filters) => {
    return Object.entries(filters)
      .filter(([_, value]) => value !== "")
      .map(([key, value]) => `${key}=${value}`)
      .join("&");
  };

  const [accounts, setAccounts] = useState([]);
  const [accountsNumber, setAccountsNumber] = useState(0);
  const { data: organizationList } = useFetch(`${organizationsURL}/forFilter`);
  const { data: referralSourceList } = useFetch(
    `${accountsURL}/referralSources`
  );
  const { data, loading, error } = useFetch(
    accountsURL,
    page,
    rowsPerPage,
    search,
    null,
    false,
    `${sortBy ? `&sortBy=${sortBy}` : ""}${
      sortOrder ? `&sortDesc=${sortOrder}` : ""
    }${
      getFilterQueryString(filters) ? `&${getFilterQueryString(filters)}` : ""
    }`
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setAccounts(data?.data?.data?.rows);
      setPageCount(data?.data?.data?.numberOfPages);
      setAccountsNumber(data?.data?.data?.totalCount);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "accounts", data: "" });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSortChange = (event) => {
    setSortBy(event.target.value);
  };

  const handleSortOrderChange = (event) => {
    setSortOrder(event.target.value);
  };

  const handleFilterChange = (event) => {
    setFilters({
      ...filters,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <Accounts
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      accounts={accounts}
      navigate={navigate}
      handleChangePage={handleChangePage}
      Open={Open}
      setOpen={setOpen}
      loading={loading}
      data={data}
      error={error}
      pageCount={pageCount}
      setAccounts={setAccounts}
      setPage={setPage}
      sortBy={sortBy}
      sortOrder={sortOrder}
      filters={filters}
      handleSortChange={handleSortChange}
      handleSortOrderChange={handleSortOrderChange}
      handleFilterChange={handleFilterChange}
      organizationList={organizationList?.data}
      accountsNumber={accountsNumber}
      referralSourceList={referralSourceList?.data}
      getFilterQueryString={getFilterQueryString}
    />
  );
}

export default AccountsPage;
